import "requestanimationframe";
import "requestidlecallback";
import "intersection-observer";
import "proxy-polyfill";
import "mdn-polyfills/Element.prototype.classList";
import "datatables.net";

import "./legacy/legacy";

import "./app/nav";
import "./app/alert";
import "./app/dialog";
import "./app/dialog-tabs";
import "./app/flyout";
import "./app/homepage-hero";
import "./app/subnav";
import "./app/tabs";
import "./app/tabs-with-content";
import "./app/video-gallery";
import "./app/youtube-embed";
import "./app/series-article";
import "./app/search-form";
import "./app/sticky-footer";
import "./app/footer-columns";
import "./app/intersect-fade-in";
import "./app/give-widget";
import "./app/site-search";
import "./app/accordion";
import "./app/modal-view-filter";
import "./app/external-link";
import "./app/table";

window.$ = window.jQuery;
